module.exports = __webpack_public_path__ + "static/media/amex.53b2595d.svg";